<template>
	<div>
		<vs-popup
			:active.sync="showValidationPopup"
			title="Validation des achats générés"
			style="z-index: 54000"
		>
			<div class="v-row">
				<p>
					Vous allez importer {{ netlinkTotal }} netlinks qui créront
					{{ purchaseTotal }} achats pour un total de {{ priceTotal }}€ pour
					{{ societyTotal }} clients.
				</p>
				<p v-if="noPriceNetlink.length > 0">
					Vous allez également importer {{ noPriceNetlink.length }} netlinks qui
					ne seront pas liés à des achats.
				</p>
			</div>
			<div class="v-row">
				<vs-table
					ref="importNetlinkTable"
					class="w-full"
					:data="purchaseRecap"
					noDataText="Aucun netlink importé."
					pagination
					v-model="selectedNetlinks"
				>
					<template slot="thead">
						<vs-th sort-key="netlink_total">Nombre de netlinks</vs-th>
						<vs-th sort-key="price_total">Prix Total</vs-th>
						<vs-th sort-key="provider_id">Prestataire</vs-th>
						<vs-th sort-key="society_name">Client</vs-th>
					</template>
					<template :data="purchaseRecap" slot-scope="{ data }">
						<vs-tr :key="index" v-for="(row, index) of data">
							<vs-td>{{ row.netlink_total }}</vs-td>
							<vs-td>{{ row.price_total }}€</vs-td>
							<vs-td>{{ getProviderNameFromId(row.provider_id) }}</vs-td>
							<vs-td>{{ row.society_name }}</vs-td>
						</vs-tr>
					</template>
				</vs-table>
			</div>
			<div class="vx-row">
				<div class="vx-col">
					<vs-button color="danger" @click="declinePurchases()"
						>Annuler les achats</vs-button
					>
				</div>
				<vs-spacer />
				<div class="vx-col">
					<vs-button color="primary" @click="acceptPurchases()"
						>Valider les achats</vs-button
					>
				</div>
			</div>
		</vs-popup>

		<vs-popup
			:active.sync="showNewProviderPopup"
			title="Ajout des nouveaux prestataires"
			button-close-hidden="true"
			@close="showNewProviderPopup = true"
			id="new-provider"
			style="z-index: 54000"
		>
			<div class="vx-row">
				<vs-table
					class="w-full"
					:data="newProviderList"
					noDataText="Aucun nouveau prestataire importé."
					v-model="selectedProviders"
					:key="refreshLine"
				>
					<template slot="thead">
						<vs-th style="pointer-events: auto"
							><vs-spacer /><vs-checkbox
								@change="checkSelectedProvider()"
								v-model="allProviderSelected" /><vs-spacer
						/></vs-th>
						<vs-th style="pointer-events: auto" sort-key="society"
							>Nom du prestataire</vs-th
						>
						<vs-th style="pointer-events: auto" sort-key="firstname"
							>Prénom du contact principal</vs-th
						>
						<vs-th style="pointer-events: auto" sort-key="lastname"
							>Nom du contact du principal</vs-th
						>
						<vs-th style="pointer-events: auto" sort-key="email"
							>Adresse mail du contact</vs-th
						>
						<vs-th style="pointer-events: auto" sort-key="phone"
							>Téléphone du contact (optionnel)</vs-th
						>
						<vs-th style="pointer-events: auto" sort-key="notValid"
							>Valide</vs-th
						>
					</template>
					<template slot-scope="{ data }">
						<vs-tr :key="index" v-for="(row, index) of data">
							<vs-td :data="row.selected">
								<vs-checkbox
									v-model="row.selected"
									@change="checkSelectedProvider(row)"
								/>
							</vs-td>
							<vs-td>{{ row.society }}</vs-td>
							<vs-td>
								<vs-input
									style="width: 150px"
									v-model="row.firstname"
									@change="validateContactInfo(row)"
								/>
							</vs-td>
							<vs-td>
								<vs-input
									style="width: 150px"
									v-model="row.lastname"
									@change="validateContactInfo(row)"
								/>
							</vs-td>
							<vs-td>
								<vs-input
									style="width: 250px"
									v-model="row.email"
									@change="validateContactInfo(row)"
								/>
							</vs-td>
							<vs-td>
								<vs-input
									style="width: 150px"
									v-model="row.phone"
									@change="validateContactInfo(row)"
								/>
							</vs-td>
							<vs-td>
								<vs-spacer />
								<vx-tooltip v-if="row.notValid" :text="row.errText">
									<vs-icon
										icon="feedback"
										color="danger"
										size="medium"
									></vs-icon>
								</vx-tooltip>
								<vx-tooltip
									v-else
									:text="'Les informations saisies sont valides !'"
								>
									<vs-icon
										style="width: 30px"
										icon="check_circle"
										color="success"
										size="medium"
									></vs-icon>
								</vx-tooltip>
								<vs-spacer />
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>
			</div>
			<div class="vx-row">
				<div class="vx-col">
					<vs-button color="danger" @click="declineProviders()"
						>Annuler</vs-button
					>
				</div>
				<vs-spacer />
				<div class="vx-col">
					<vs-button color="primary" @click="acceptProviders(newProviderList)"
						>Valider</vs-button
					>
				</div>
			</div>
		</vs-popup>

		<vs-popup
			title="Import de netlinks"
			:active.sync="isPopupActive"
			style="z-index: 54000"
		>
			<input
				id="fileinputtk"
				type="file"
				accept=".csv,.xlsx"
				@change="readCSV($event, netlinkList)"
				style="display: none"
			/>
			<div class="w-full" style="padding: 20px !important">
				<vx-card>
					<div class="vx-row w-full">
						<div class="vx-col">
							<vs-button color="primary" @click="csvImport"
								>Ajouter un fichier</vs-button
							>
						</div>
						<div class="vx-col">
							<vs-button color="primary" @click="downloadTemplate"
								>Télécharger le template</vs-button
							>
						</div>
					</div>
				</vx-card>

				<vx-card class="mt-2" :key="refreshCard">
					<div v-if="netlinkList.length > 0" class="w-full">
						<div class="vx-row">
							<div class="vx-col pt-2">
								<span>Nombre de lignes affichées : </span>
							</div>
							<div class="vx-col">
								<vs-select
									autocomplete
									v-model="maxItemsNetlink"
									class="select-large pb-4"
								>
									<vs-select-item
										:key="index"
										:value="item"
										:text="item"
										v-for="(item, index) in pageNumberOptions"
										class="w-full"
									/>
								</vs-select>
							</div>
							<div class="vx-col pt-2">
								<span>Filtrer par nom du lien : </span>
							</div>
							<div class="vx-col">
								<vs-input v-model="linkFilter" />
							</div>
						</div>
						<div class="vx-row mb-5">
							<strong class="vx-col">
								Nombre de résultats total : {{ netlinkList.length }}
							</strong>
							<strong class="vx-col">
								Nombre de résultats sélectionnés :
								{{ countSelectedNetlinks(netlinkList) }}
							</strong>
						</div>
						<div class="vx-row w-full">
							<vs-table
								ref="importNetlinkTable"
								class="w-full"
								:data="netlinkList"
								noDataText="Aucun netlink importé."
								pagination
								:max-items="maxItemsNetlink"
								:key="refreshList"
							>
								<template slot="thead">
									<vs-th style="pointer-events: auto"
										><vs-spacer /><vs-checkbox
											@change="checkSelected()"
											v-model="allNetlinkSelected" /><vs-spacer
									/></vs-th>
									<vs-th style="pointer-events: auto" sort-key="url_bought"
										>Lien acheté</vs-th
									>
									<vs-th style="pointer-events: auto" sort-key="landing_page"
										>Page de destination</vs-th
									>
									<vs-th style="pointer-events: auto" sort-key="anchor_type"
										>Type ancre</vs-th
									>
									<vs-th style="pointer-events: auto" sort-key="anchor"
										>Ancre</vs-th
									>
									<vs-th style="pointer-events: auto" sort-key="link_type"
										>Type de lien</vs-th
									>
									<vs-th style="pointer-events: auto" sort-key="price"
										>Prix</vs-th
									>
									<vs-th style="pointer-events: auto" sort-key="contract_id"
										>N° contrat</vs-th
									>
									<vs-th style="pointer-events: auto" sort-key="mission_id"
										>Prestation</vs-th
									>
									<vs-th style="pointer-events: auto" sort-key="mission_id"
										>Statut de la prestation</vs-th
									>
									<vs-th style="pointer-events: auto" sort-key="provider_id"
										>Prestataire</vs-th
									>
									<vs-th style="pointer-events: auto" sort-key="renew_duration"
										>Renouvellement</vs-th
									>
									<vs-th style="pointer-events: auto" sort-key="status"
										>Status</vs-th
									>
									<vs-th style="pointer-events: auto" sort-key="period_date"
										>Période</vs-th
									>
									<vs-th style="pointer-events: auto" sort-key="notValid"
										>Valide</vs-th
									>
								</template>

								<template slot-scope="{ data }">
									<vs-tr
										:data="row"
										:style="
											'background: ' +
											(row.notValid
												? 'rgba(234,84,85,.1)'
												: 'rgba(40,199,111,.1)') +
											' !important;'
										"
										:state="row.notValid ? 'danger' : 'success'"
										:key="index"
										v-for="(row, index) of data"
									>
										<vs-td :data="row.selected">
											<vs-checkbox
												v-model="row.selected"
												@change="checkSelected(row)"
											/>
										</vs-td>
										<vs-td :data="row.url_bought">
											<vs-input
												v-model="row.url_bought"
												@change="validateRow(row)"
											/>
										</vs-td>

										<vs-td :data="row.landing_page">
											<vs-input
												v-model="row.landing_page"
												@change="validateRow(row)"
											/>
										</vs-td>

										<vs-td :data="row.anchor_type" style="min-width: 100px">
											<vs-select
												v-model="row.anchor_type"
												@change="validateRow(row)"
												class="w-full select-medium mr-2"
											>
												<vs-select-item
													:key="index"
													:value="item.value"
													:text="item.text"
													v-for="(item, index) in anchorTypes"
													class="w-full"
												/>
											</vs-select>
										</vs-td>
										<vs-td :data="row.anchor">
											<vs-input
												v-model="row.anchor"
												@change="validateRow(row)"
											/>
										</vs-td>

										<vs-td :data="row.link_type" style="min-width: 100px">
											<vs-select
												v-model="row.link_type"
												@change="validateRow(row)"
												class="w-full select-medium mr-2"
											>
												<vs-select-item
													:key="index"
													:value="item.id"
													:text="item.name"
													v-for="(item, index) in linkTypes"
													class="w-full"
												/>
											</vs-select>
										</vs-td>

										<vs-td :data="row.price">
											<vs-input
												style="width: 70px"
												v-model="row.price"
												@change="validateRow(row)"
											/>
										</vs-td>

										<vs-td v-if="selectedContract">
											<vx-tooltip
												:text="getSocietyNameFromContractId(selectedContract)"
												><vs-input
													style="width: 70px"
													v-model="selectedContract"
													disabled
											/></vx-tooltip>
										</vs-td>

										<vs-td v-else :data="row.contract_id">
											<vx-tooltip
												:text="getSocietyNameFromContractId(row.contract_id)"
												><vs-input
													style="width: 70px"
													v-model="row.contract_id"
													@change="validateRow(row)"
											/></vx-tooltip>
										</vs-td>

										<vs-td :data="row.mission_id" style="min-width: 100px">
											<vs-select
												v-model="row.mission_id"
												@change="validateRow(row)"
												no-data="Aucune prestation"
												class="w-full select-medium mr-2"
											>
												<vs-select-item
													:key="index"
													:value="item[0]"
													:text="item[1]"
													v-for="(item, index) in getAllMissionsForContract(
														row.contract_id,
														row
													)"
													class="w-full"
												/>
											</vs-select>
										</vs-td>

										<vs-td :data="row.mission_id" class="text-center">
											{{ getMissionStatus(row.mission_id) }}
										</vs-td>

										<vs-td :data="row.provider_id" style="min-width: 100px">
											<vs-select
												v-model="row.provider_id"
												@change="validateRow(row)"
												no-data="Aucun prestataire"
												class="w-full select-medium mr-2"
											>
												<vs-select-item
													:key="index"
													:value="item.id"
													:text="item.society"
													v-for="(item, index) in netlinkProviders"
													class="w-full"
												/>
											</vs-select>
										</vs-td>

										<vs-td :data="row.renew_duration">
											<vs-select
												v-model="row.renew_duration"
												@change="validateRow(row)"
												class="w-full select-medium mr-2"
											>
												<vs-select-item
													:key="index"
													:value="item.value"
													:text="item.text"
													v-for="(item, index) in renewDurations"
													class="w-full"
												/>
											</vs-select>
										</vs-td>

										<vs-td :data="row.status" style="min-width: 100px">
											<vs-select
												v-model="row.status"
												@change="validateRow(row)"
												class="w-full select-medium mr-2"
											>
												<vs-select-item
													:key="index"
													:value="item.value"
													:text="item.text"
													v-for="(item, index) in netlinkStatus"
													class="w-full"
												/>
											</vs-select>
										</vs-td>

										<vs-td>
											<vx-input-group class="bottom">
												<flat-pickr
													id="flatpickr"
													v-model="row.period_date"
													:config="configDatePicker"
													style="width: 100px; text-align: center"
													@keydown.native.delete.capture.stop.prevent
												/>
											</vx-input-group>
										</vs-td>

										<vs-td>
											<vs-spacer />
											<vx-tooltip v-if="row.notValid" :text="row.errText">
												<vs-icon
													icon="feedback"
													color="danger"
													size="medium"
												></vs-icon>
											</vx-tooltip>
											<vx-tooltip v-else :text="'Le netlink est valide !'">
												<vs-icon
													style="width: 30px"
													icon="check_circle"
													color="success"
													size="medium"
												></vs-icon>
											</vx-tooltip>
											<vs-spacer />
										</vs-td>
									</vs-tr>
								</template>
							</vs-table>
						</div>
						<div class="vx-row">
							<vs-spacer />
							<div class="vx-col">
								<vs-button
									color="primary"
									@click="submitPurchases"
									:disabled="loading"
									>Enregistrer les netlinks</vs-button
								>
							</div>
						</div>
					</div>
					<div v-else>
						<vx-card>
							<h2>
								Veuillez importer un fichier. Vous trouverez le template en
								cliquant sur le bouton correspondant ci-dessus.
							</h2>
						</vx-card>
					</div>
				</vx-card>
			</div>
		</vs-popup>
	</div>
</template>

<script>
import store from "@/store/store";
import VueCookies from "vue-cookies";
import XLSX from "xlsx";

import Mission from "@/entities/Mission";
import Netlink from "@/entities/Netlink";
import Product from "@/entities/Product";
import Purchase from "@/entities/Purchase";
import Validator from "@/entities/Validator";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";

import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";

import VxTooltip from "../../components/widgets/vx-tooltip/VxTooltip.vue";

export default {
	components: {
		VxTooltip,
		flatPickr,
		monthSelect,
	},
	name: "ImportNetlinksPopup",
	mixins: [dbFieldConvertor],
	props: {
		apiUrl: String,
		selectedContract: Number,
		popupActive: Boolean,
		netlink_types: Array,
		services: Array,
		providers: Array,
		netlink: Array,
	},
	data() {
		return {
			isPopupActive: this.$props.popupActive,
			refreshList: 0,
			linkTypes: this.$props.netlink_types.filter((row) => row.is_dns == 0),

			showValidationPopup: false,
			loading: false,

			contractsSocietiesWithName: null,

			pageNumberOptions: [5, 10, 25, 50, 100],
			maxItemsNetlink: 25,

			linkFilter: "",

			netlinkService: null,
			netlinkProviders: [],
			netlinkList: [],
			netlinkListFull: [],
			noPriceNetlink: [],

			allNetlinkSelected: true,
			selectedNetlinks: [],

			allNetlinkSelected: true,
			selectedNetlinks: [],

			splitNetlinks: [],
			purchaseRecap: null,
			purchaseTotal: 0,
			netlinkTotal: 0,
			societyTotal: 0,
			priceTotal: 0,

			netlinkStatus: [
				{ text: "Actif", value: 0 },
				{ text: "En\u00a0attente", value: 1 },
				{ text: "Refusé", value: 2 },
				{ text: "Terminé", value: 3 },
				{ text: "En\u00a0cours\u00a0de\u00a0rédaction", value: 4 },
				{ text: "Annulé", value: 5 },
			],
			anchorTypes: [
				{ text: "Brand et Générique", value: 0 },
				{ text: " Semi optimisée", value: 1 },
				{ text: "Générique", value: 2 },
				{ text: "Non optimisée", value: 3 },
				{ text: "Optimisée", value: 4 },
			],
			renewDurations: [
				{ text: "A vie", value: 0 },
				{ text: "Mensuel", value: 1 },
				{ text: "Annuel", value: 12 },
			],
			configDatePicker: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light",
					}),
				],
			},
			allMissions: [],
			missionStatus: [
				{ text: "Actif", value: 1 },
				{ text: "En\u00a0pause", value: 3 },
				{ text: "Livré", value: 7 },
				{ text: "Terminé", value: 4 },
			],
			products: [],

			//providers
			providers: [],
			providersServices: [],
			newProviderList: [],
			refreshCard: 0,
			showNewProviderPopup: false,
			allProviderSelected: true,
			selectedProviders: [],
			allProviderSelected: true,
			refreshLine: 0,
		};
	},
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
	},
	watch: {
		/*
		 * services: function() {
		 *     this.getNetlinkService()
		 * },
		 */
		services: function () {
			this.createNetlinkProviderList(this.netlinkService);
		},
		netlinkService: function (data) {
			this.createNetlinkProviderList(data);
		},
		netlinkList: function (data) {
			this.validateAllRows(data);
		},
		linkFilter: function (data) {
			this.$refs.importNetlinkTable.searchx = data;
		},
		refreshCard: function () {
			this.newProviderList = [];
		},
	},
	created() {
		this.createNetlinkProviderList(this.netlinkService);
		this.getAllSocietiesContractsWithName();

		this.providers = [];
		this.getAllProviders();

		this.products = [];
		this.allMissions = [];

		Product.getAllProducts((errr, result) => {
			this.products = result.data;
			Mission.getAllMissions((err, res) => {
				this.allMissions = res;
			});
		});

		Mission.getAllMissions((err, res) => {
			this.allMissions = res;
		});

		this.$http.get(this.apiUrl + "providersServices/all").then((res) => {
			this.providersServices = res.data;
		});
	},

	methods: {
		openLoading() {
			this.loading = true;
			this.$vs.loading();
		},

		closeLoading() {
			this.loading = false;
			this.$vs.loading.close();
			window.dispatchEvent(new Event("resize"));
		},

		checkSelected(row = null) {
			if (row) {
				if (
					this.countSelectedNetlinks(this.netlinkList) ==
					this.netlinkList.length
				) {
					this.allNetlinkSelected = true;
				} else {
					this.allNetlinkSelected = false;
				}
			} else {
				if (this.allNetlinkSelected == true) {
					for (let i = 0; i < this.netlinkList.length; i++) {
						this.netlinkList[i].selected = true;
					}
				} else {
					for (let i = 0; i < this.netlinkList.length; i++) {
						this.netlinkList[i].selected = false;
					}
				}
			}
		},

		checkSelectedProvider(row = null) {
			if (row) {
				if (
					this.countSelectedProviders(this.newProviderList) ==
					this.newProviderList.length
				) {
					this.allProviderSelected = true;
				} else {
					this.allProviderSelected = false;
				}
			} else {
				if (this.allProviderSelected == true) {
					for (let i = 0; i < this.newProviderList.length; i++) {
						this.newProviderList[i].selected = true;
					}
				} else {
					for (let i = 0; i < this.newProviderList.length; i++) {
						this.newProviderList[i].selected = false;
					}
				}
			}
		},

		getAllProviders() {
			this.$http.get(this.apiUrl + "providers/allws").then((res) => {
				this.providers = res.data;
			});
		},

		getErrorTexts(row) {
			let fieldsValidatorHeader = {
				url_bought: "Lien acheté",
				landing_page: "Page de destination",
				contract_id: "N° contrat",
				mission_id: "Prestation",
				provider_id: "Prestataire",
				price: "Prix",
				status: "Status",
				anchor_type: "Type ancre",
				// "anchor_type": "Type ancre",
				link_type: "Type de lien",
				renew_duration: "Renouvellement",
				period_date: "Période",
			};

			let errorTexts = "";
			let validatorKeys = Object.keys(row.validators);
			for (let field_validator of validatorKeys) {
				if (row.validators[field_validator].errText != "") {
					errorTexts =
						errorTexts +
						"\n" +
						fieldsValidatorHeader[field_validator] +
						" : " +
						row.validators[field_validator].errText;
				}
			}

			return errorTexts;
		},

		getProviderErrorTexts(row) {
			let fieldsValidatorHeader = {
				firstname: "Prénom",
				lastname: "Nom",
				email: "Email",
				phone: "N° Téléphone",
			};

			let errorTexts = "";
			let validatorKeys = Object.keys(row.validators);
			for (let field_validator of validatorKeys) {
				if (row.validators[field_validator].errText != "") {
					errorTexts =
						errorTexts +
						"\n" +
						fieldsValidatorHeader[field_validator] +
						" : " +
						row.validators[field_validator].errText;
				}
			}

			return errorTexts;
		},

		checkRowHaveNotValidStates(row) {
			let validatorKeys = Object.keys(row.validators);
			for (let field_validator of validatorKeys) {
				if (row.validators[field_validator].notValid) {
					return true;
				}
			}
			return false;
		},

		checkAllRowHaveNotValidStates(netlinkList) {
			for (let netlink of netlinkList) {
				if (this.checkRowHaveNotValidStates(netlink)) {
					return true;
				}
			}
			return false;
		},

		checkNetlinkIsDuplicateFromList(netlink, list2, adjustRowCount = 0) {
			let concatenatedNetlink = netlink.url_bought + netlink.landing_page;
			if (list2) {
				let duplicateInList = list2.filter(
					(netlink) =>
						concatenatedNetlink == netlink.url_bought + netlink.landing_page
				);
				if (duplicateInList.length > adjustRowCount) {
					return true;
				}
			}
			return false;
		},

		checkDuplicateInLinkLists(list1, list2) {
			let concatenatedAddedNetlinks = list1.map(
				(netlink) => netlink.url_bought + netlink.landing_page
			);
			let duplicateInList = list2.filter((netlink) =>
				concatenatedAddedNetlinks.includes(
					netlink.url_bought + netlink.landing_page
				)
			);
			if (duplicateInList.length > 0) {
				return true;
			}
			return false;
		},

		checkAddedNetlinksNotDuplicate(addedNetlinks) {
			let isError = false;
			let concatenatedAddedNetlinks = addedNetlinks.map(
				(netlink) => netlink.url_bought + netlink.landing_page
			);
			let duplicateInList = addedNetlinks.filter((netlink) =>
				concatenatedAddedNetlinks.includes(
					netlink.url_bought + netlink.landing_page
				)
			);
			if (duplicateInList.length > 0) {
				this.$vs.notify({
					title: "Erreur",
					text: "Il y a des doublons dans votre liste de netlinks:",
				});
				isError = true;
			}
			let duplicateInGlobalNetlink = this.netlink.filter((netlink) =>
				concatenatedAddedNetlinks.includes(
					netlink.url_bought + netlink.landing_page
				)
			);
			if (duplicateInGlobalNetlink.length > 0) {
				this.$vs.notify({
					title: "Erreur",
					text: "Certains des netlinks existent déjà dans la base de donnée.",
				});
				isError = true;
			}

			return isError;
		},

		/**
		 * Validate all fields of a row
		 */
		validateRow(row) {
			let validatorKeys = Object.keys(row.validators);
			for (let field_validator of validatorKeys) {
				// //console.log("field_validator", field_validator)
				if (field_validator === "contract_id") {
					if (!this.selectedContract) {
						let foundContract = this.contractsSocietiesWithName.findIndex(
							(contract_society) =>
								contract_society.contract_id == row[field_validator]
						);
						if (foundContract < 0) {
							row.validators[field_validator].valid = false;
							row.validators[field_validator].notValid = true;
							row.validators[field_validator].validText = "";
							row.validators[field_validator].errText =
								"Le numéro de contrat n'existe pas.";
						} else {
							row.validators[field_validator].valid = true;
							row.validators[field_validator].notValid = false;
							row.validators[field_validator].validText = "Le contrat existe.";
							row.validators[field_validator].errText = "";
						}
					}
				} else {
					row.validators[field_validator].check(row[field_validator]);
					if (!row[field_validator]) {
						row.validators[field_validator].valid = false;
						row.validators[field_validator].notValid = true;
						row.validators[field_validator].validText = "";
						row.validators[field_validator].errText = "Champ obligatoire.";
					}
				}
			}

			if (this.checkNetlinkIsDuplicateFromList(row, this.netlinkList, 1)) {
				row.validators["url_bought"].valid = false;
				row.validators["url_bought"].notValid = true;
				row.validators["url_bought"].validText = "";
				row.validators["url_bought"].errText =
					"La paire de netlink existe déjà dans la liste.";
			}

			if (this.checkNetlinkIsDuplicateFromList(row, this.netlink)) {
				row.validators["url_bought"].valid = false;
				row.validators["url_bought"].notValid = true;
				row.validators["url_bought"].validText = "";
				row.validators["url_bought"].errText =
					"La paire de netlink a déjà été importée.";
			}

			let today = new Date(Date.now());
			console.log("Period before", row.period_date);
			if (
				!row.period_date ||
				Number(row.period_date.split("/")[0]) > 12 ||
				Number(row.period_date.split("/")[0]) < 1 ||
				row.period_date.split("/")[1].length != 4 ||
				row.period_date.split("/").length != 2
			)
				row.period_date = `${today.getMonth() + 1}/${today.getFullYear()}`;
			console.log("Period After", row.period_date);
			row.notValid = this.checkRowHaveNotValidStates(row);
			row.errText = row.notValid ? this.getErrorTexts(row) : "";
		},

		validateContactInfo(row) {
			let validatorKeys = Object.keys(row.validators);
			for (let field_validator of validatorKeys) {
				row.validators[field_validator].check(row[field_validator]);
				if (field_validator !== "phone") {
					if (!row[field_validator]) {
						row.validators[field_validator].valid = false;
						row.validators[field_validator].notValid = true;
						row.validators[field_validator].validText = "";
						row.validators[field_validator].errText = "Champ obligatoire.";
					}
				}
			}
			row.notValid = this.checkRowHaveNotValidStates(row);
			row.errText = row.notValid ? this.getProviderErrorTexts(row) : "";
			this.refreshLine++;
		},

		getMissionStatus(mission_id) {
			if (!mission_id) return "";
			if (
				this.missionStatus.filter(
					(status) =>
						status.value ==
						this.allMissions.filter((mission) => mission.id == mission_id)[0]
							.status
				).length == 0
			)
				return "";
			return this.missionStatus.filter(
				(status) =>
					status.value ==
					this.allMissions.filter((mission) => mission.id == mission_id)[0]
						.status
			)[0].text;
		},

		/**
		 * Validate all rows
		 */
		validateAllRows(netlinkList) {
			for (let row of netlinkList) {
				this.validateRow(row);
			}
			if (this.newProviderList.length > 0) this.showNewProviderPopup = true;
		},

		createNetlinkProviderList(netlinkServiceId) {
			let service_id = netlinkServiceId;
			if (!service_id) {
				service_id = this.getNetlinkService();
			}
			//Filter Providers on service id
			let netlinkProviderList = [];
			if (service_id > 0 && this.providers && this.providers.length > 0) {
				for (let i = 0; i < this.providers.length; i++) {
					let splitServiceList = this.providers[i].service_id_list
						? this.providers[i].service_id_list.split(",")
						: [];

					let foundService = splitServiceList.indexOf(service_id.toString());
					if (foundService.toString() >= "0") {
						netlinkProviderList.push(this.providers[i]);
					}
				}
				this.netlinkProviders = netlinkProviderList;
			}
		},

		getProviderNameFromId(provider_id) {
			let foundProvider = this.providers.findIndex(
				(provider) => provider.id == provider_id
			);
			if (foundProvider >= 0) {
				return this.providers[foundProvider].society;
			}
			return "";
		},

		findSocietyName(contractsSocietiesWithName, contract_id) {
			let foundSociety = contractsSocietiesWithName
				? contractsSocietiesWithName.findIndex(
						(row) => row.contract_id == contract_id
				  )
				: -1;
			if (foundSociety >= 0) {
				return contractsSocietiesWithName[foundSociety].society_name;
			}
			return "";
		},

		getSocietyNameFromContractId(contract_id) {
			if (this.contractsSocietiesWithName) {
				return this.findSocietyName(
					this.contractsSocietiesWithName,
					contract_id
				);
			} else {
				this.getAllSocietiesContractsWithName().then((data) => {
					return this.findSocietyName(data, contract_id);
				});
			}
		},

		getAllSocietiesContractsWithName() {
			return new Promise((resolve, reject) => {
				this.$http
					.get(this.apiUrl + "contract/getscn")
					.then((res) => {
						this.contractsSocietiesWithName = res.data;
						resolve(res.data);
					})
					.catch((err) => {
						//console.log("getAllSocietiesContractsWithName", this.apiUrl + "contract/getscn", err);
						reject(err);
					});
			});
		},

		getAllMissionsForContract(contractId, row) {
			// //console.log(contractId)
			let missionList = [];
			for (let mission of this.allMissions.filter(
				(mission) => mission.contract_id == contractId
			)) {
				let item;

				if (mission.commentary) {
					if (
						this.products.filter(
							(product) =>
								product.id == mission.products_id && product.sub_category == 7
						).length > 0
					)
						item = `${
							this.products.filter(
								(product) =>
									product.id == mission.products_id && product.sub_category == 7
							)[0].perform
						}: ${mission.commentary}`;
				} else {
					if (
						this.products.filter(
							(product) =>
								product.id == mission.products_id && product.sub_category == 7
						).length > 0
					)
						item = this.products.filter(
							(product) =>
								product.id == mission.products_id && product.sub_category == 7
						)[0].perform;
				}
				if (item) missionList.push([mission.id, item]);
			}
			if (missionList.length == 0) row.mission_id = null;
			return missionList;
			// //console.log("getAllMissionsForContract")
		},

		getNetlinkService() {
			let netlinkService = this.services.find(
				(service) => service.name == "Netlinking"
			);
			this.netlinkService = netlinkService ? netlinkService.id : null;
			return this.netlinkService;
		},

		checkNetlinks(netlinks) {
			let newNetlinks = [];
			for (let i = 0; i < netlinks.length; i++) {
				let foundNetlink = this.netlink.findIndex(
					(nl) =>
						nl.url_bought == netlinks[i].url_bought &&
						nl.landing_page == netlinks[i].landing_page
				);
				if (foundNetlink < 0) {
					newNetlinks.push(netlinks[i]);
				}
			}
			return newNetlinks;
		},
		addNetlinks(netlinks) {
			let netlinkList = this.checkNetlinks(netlinks);
			netlinkList = netlinkList.sort((a, b) => {
				let uniqA = a.url_bought + a.landing_page;
				let uniqB = b.url_bought + b.landing_page;
				if (uniqA < uniqB) {
					return -1;
				}
				if (uniqA > uniqB) {
					return 1;
				}
				return 0;
			});

			netlinkList = netlinkList.filter((item, pos, ary) => {
				return (
					!pos ||
					item.url_bought + item.landing_page !=
						ary[pos - 1].url_bought + ary[pos - 1].landing_page
				);
			});

			netlinkList = netlinkList.filter(
				(row) => row.url_bought != null || row.landing_page != null
			);
			this.netlinkList = netlinkList;
		},
		csvImport() {
			this.newProviderList = [];
			let inputFile = document.getElementById("fileinputtk");
			inputFile.click();
		},
		readCSV(file, netlinkList) {
			let _this = this;
			let reader = new FileReader();
			const callback = this.addNetlinks;
			reader.onload = function (e) {
				let fields = [
					"url_bought",
					"landing_page",
					"contract_id",
					"mission_id",
					"provider_id",
					"price",
					"status",
					"anchor_type",
					"anchor",
					"link_type",
					"renew_duration",
					"period_date",
				];
				let fieldsValidator = {
					url_bought: "websiteConstraint",
					landing_page: "websiteConstraint",
					contract_id: "isNumberConstaint",
					mission_id: "statusConstraint",
					provider_id: "statusConstraint",
					price: "priceConstraint",
					status: "statusConstraint",
					anchor_type: "statusConstraint",
					anchor: "statusConstraint",
					link_type: "statusConstraint",
					renew_duration: "statusConstraint",
					period_date: "statusConstraint",
				};

				let providerFields = ["firstname", "lastname", "email", "phone"];
				let providerFieldsValidator = {
					firstname: "nameConstraint",
					lastname: "nameConstaint",
					email: "emailConstraint",
					phone: "phoneConstraint",
				};

				let mergedNetlinks = [];
				let data = new Uint8Array(e.target.result);
				let workbook = XLSX.read(data, { type: "array" });
				// let sheet_name_list = workbook.SheetNames

				//Prestataire: Vérification + this.newProviderList pour les nouveaux prestataires et leurs contacts
				let fetched_providers = XLSX.utils.sheet_to_json(
					workbook.Sheets["Prestataires"],
					{ raw: true, defval: null }
				);
				if (fetched_providers.length > 0) {
					for (let i of fetched_providers) {
						if (
							i["ID"] &&
							_this.providers.filter(
								(provider) =>
									provider.id == i["ID"] &&
									provider.society == i["Nom du Prestataire"]
							).length == 0
						) {
							_this.$vs.notify({
								title: "Erreur",
								text: "Une erreur a été détectée, veuillez vérifier votre liste de prestataires.",
							});
							_this.refreshCard++;
							return;
						}
						if (
							i["ID"] &&
							_this.providersServices
								.filter(
									(providerService) => providerService.provider_id == i["ID"]
								)
								.filter(
									(pservice) =>
										_this.services.filter(
											(sv) =>
												sv.name == "Netlinking" && sv.id == pservice.service_id
										).length > 0
								).length == 0
						) {
							_this.$vs.notify({
								title: "Erreur",
								text: "Une erreur a été détectée, veuillez vérifier votre liste de prestataires.",
							});
							_this.refreshCard++;
							return;
						}
						if (!i["ID"]) {
							if (
								_this.providers.filter(
									(provider) => provider.society == i["Nom du Prestataire"]
								).length > 0
							) {
								_this.$vs.notify({
									title: "Erreur",
									text: "Un ou plusieurs prestataires existent déjà, veuillez vérifier votre liste de prestataires.",
								});
								_this.refreshCard++;
								return;
							}
							_this.newProviderList.push({
								society: i["Nom du Prestataire"],
								firstname: i["Prénom du contact principal"],
								lastname: i["Nom du contact du principal"],
								email: i["Adresse mail du contact"],
								phone: i["Téléphone du contact (optionnel)"]
									? String(i["Téléphone du contact (optionnel)"])
									: null,
								selected: true,
							});

							let providerOutput = {
								validators: {},
								notValid: false,
								errText: "",
							};
							for (let x = 0; x < providerFields.length; x++) {
								providerOutput[providerFields[x]] = null;
								providerOutput.validators[providerFields[x]] = new Validator({
									constraintName: providerFieldsValidator[providerFields[x]],
								});
								if (
									_this.newProviderList[_this.newProviderList.length - 1][
										providerFields[x]
									] &&
									_this.newProviderList[_this.newProviderList.length - 1][
										providerFields[x]
									] !== null
								)
									providerOutput[providerFields[x]] =
										_this.newProviderList[_this.newProviderList.length - 1][
											providerFields[x]
										];
							}

							_this.newProviderList[_this.newProviderList.length - 1][
								"validators"
							] = providerOutput.validators;
							_this.newProviderList[_this.newProviderList.length - 1][
								"notValid"
							] = providerOutput.notValid;
							_this.newProviderList[_this.newProviderList.length - 1][
								"errText"
							] = providerOutput.errText;
						}
					}
				}

				let fetched_netlinks = XLSX.utils.sheet_to_json(
					workbook.Sheets["Résultats"],
					{ raw: true, defval: null }
				);
				let fetched_providerNames = XLSX.utils.sheet_to_json(
					workbook.Sheets["Données"],
					{ raw: true, defval: null }
				);
				// //console.log("fetched_netlinks", fetched_netlinks)
				if (fetched_netlinks.length > 0) {
					mergedNetlinks = [...netlinkList];
					// //console.log("mergedNetlinks", mergedNetlinks)
					fetched_netlinks.forEach((row) => {
						if (
							!row.provider_id &&
							fetched_providerNames[fetched_netlinks.indexOf(row)]
						)
							row.provider_id =
								fetched_providerNames[fetched_netlinks.indexOf(row)][
									"Prestataire"
								];

						let rowOutput = {
							validators: {},
							notValid: false,
							errText: "",
							selected: true,
						};
						for (let i = 0; i < fields.length; i++) {
							rowOutput[fields[i]] = null;
							rowOutput.validators[fields[i]] = new Validator({
								constraintName: fieldsValidator[fields[i]],
							});
							if (row[fields[i]] && row[fields[i]] !== null)
								rowOutput[fields[i]] = row[fields[i]];
						}

						let netlinkFound = false;
						for (let i = 0; i < mergedNetlinks.length; i++) {
							// //console.log(Object.entries(mergedNetlinks[i]).toString(),Object.entries(rowOutput).toString(),Object.entries(mergedNetlinks[i]).toString() === Object.entries(rowOutput).toString())
							if (
								Object.entries(mergedNetlinks[i]).toString() ===
								Object.entries(rowOutput).toString()
							)
								netlinkFound = true;
						}

						if (!netlinkFound) mergedNetlinks.push(rowOutput);
					});
					// //console.log(mergedNetlinks)
					callback(mergedNetlinks);
				}
			};
			reader.readAsArrayBuffer(file.target.files[0]);
		},
		addPurchase(purchase, netlinks, isDNS = false) {
			return new Promise((resolve, reject) => {
				let today = new Date(Date.now());
				let formatedDate = today.toISOString().substring(0, 10);
				formatedDate = formatedDate.split("/").reverse().join("-");
				formatedDate = formatedDate + " 02:00:00";

				let period = `${purchase.period_date
					.split("/")
					.reverse()
					.join("-")}-01 02:00:00`;

				//console.log(purchase.price, this.convertFrenchNumberToInternational(purchase.price));
				this.$http
					.post(this.apiUrl + "purchase/add", {
						price: this.convertFrenchNumberToInternational(purchase.price),
						recurrence: purchase.recurrence,
						margin_price: this.convertFrenchNumberToInternational(
							purchase.marginPrice
						),
						margin_rate: purchase.marginRate,
						is_billable: purchase.isBillable,
						commentary: purchase.commentary,
						bought_at: purchase.bought_at,
						contract_id: purchase.contract_id,
						contract_society_id: purchase.contract_society_id,
						users_id: purchase.users_id,
						service_id: purchase.service_id,
						is_delivered: purchase.is_delivered,
						recurrence_active: purchase.recurrence,
						user_id: purchase.user_id,
						period_date: period,
						mission_id: purchase.mission_id,
						users_id: purchase.provider_id,
					})
					.then((res) => {
						/*
						 * //console.log(res)
						 * this.purchaseId = res.data.insertId
						 * //console.log(this.purchaseId)
						 * this.showNetlinkPopup = true
						 */
						//this.$store.dispatch("getAllPurchasesWithRecurring");
						/*
						 * Send a success notification to the user
						 * this.$vs.notify({title:'Succès',text:"Achat ajouté avec succès."})
						 */
						resolve([res.data.insertId, netlinks]);
					})
					.catch((err) => {
						//console.log(err);
						// this.$vs.notify({title:'Echec',text:"L'achat n'a pas été ajouté."})
						reject(null);
					});
			});
		},

		addDNS() {
			// CREATE DNS OBJECT
			return new Promise((resolve, reject) => {
				this.oneDns = this.$refs.dnsPurchasePopup.getDnsPopup();
				//console.log("this.purchaseId", this.purchaseId);
				if (this.purchaseId) {
					//console.log(this.purchaseId);
					this.oneDns.purchase_id = this.purchaseId;
				}
				if (this.providerId) {
					//console.log(this.providerId);
					this.oneDns.provider_id = this.providerId;
				}
				let formatedDate = this.oneDns.purchase_date
					.split("/")
					.reverse()
					.join("-");
				this.oneDns.purchase_date = formatedDate;
				this.oneDns.renew_date = formatedDate;
				let newDns = new Dns(this.oneDns);
				//console.log(newDns);
				newDns.create((err, res) => {
					if (err) {
						//console.log(err);
						reject(err);
					}
					if (res) {
						//console.log(res);
						this.$store.dispatch("getAllDns");
						resolve(res.data.insertId);
					}
				});
			});
		},

		createNetlink(purchase_id = null, netlink_data, isDNS) {
			return new Promise((resolve, reject) => {
				let netlink = Netlink.getFormFields();
				//console.log("netlink_data", netlink_data);
				netlink.urlBought = netlink_data.url_bought;
				netlink.landingPage = netlink_data.landing_page;
				netlink.contract_id = netlink_data.contract_id;
				netlink.anchorType = netlink_data.anchor_type;
				netlink.anchorType = netlink_data.anchor;
				netlink.linkType = netlink_data.link_type ? netlink_data.link_type : 1;
				netlink.price = netlink_data.price;
				netlink.status = netlink_data.status;
				netlink.renew_duration = netlink_data.renew_duration
					? netlink_data.renew_duration
					: 0;

				netlink.purchase_id = purchase_id;

				let society_idIndex = this.contractsSocietiesWithName.findIndex(
					(row) => row.contract_id == netlink_data.contract_id
				);
				netlink.society_id =
					society_idIndex >= 0
						? this.contractsSocietiesWithName[society_idIndex].society_id
						: null;

				let newNetlink = new Netlink(netlink);
				//console.log(newNetlink);
				newNetlink.create((err, res) => {
					if (err)
						if (res) {
							//console.log(err);
							//console.log(res.data.insertId);
							//this.$store.dispatch("getAllNetlink");
							newNetlink.id = res.data.insertId;
							// this.netlink_list.push(newNetlink)
							resolve(res.data.insertId);
						}
				});
			});
		},

		addNetlink(purchase_id, netlinks, isDNS = false) {
			// IMPLEMENT DNS LINKING
			return new Promise((resolve, reject) => {
				let requests = [];
				for (let netlink of netlinks) {
					requests.push(this.createNetlink(purchase_id, netlink, isDNS));
				}
				Promise.all(requests)
					.then((responses) => {
						resolve(responses);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},

		countSelectedNetlinks(netlinks) {
			let selectedNetlinksCount = 0;
			for (let i = 0; i < netlinks.length; i++) {
				if (netlinks[i].selected == true) {
					selectedNetlinksCount += 1;
				}
			}
			return selectedNetlinksCount;
		},

		countSelectedProviders(providers) {
			let selectedProvidersCount = 0;
			for (let i = 0; i < providers.length; i++) {
				if (providers[i].selected == true) {
					selectedProvidersCount += 1;
				}
			}
			return selectedProvidersCount;
		},

		filterOutSelection(netlinks) {
			let selectedNetlinks = [];
			for (let i = 0; i < netlinks.length; i++) {
				if (netlinks[i].selected == true) {
					selectedNetlinks.push(netlinks[i]);
				}
			}
			return selectedNetlinks;
		},

		splitByProvider(netlinks) {
			let providers_id = [];
			let splitedNetlinks = [];
			for (let i = 0; i < netlinks.length; i++) {
				let foundProvider = providers_id.indexOf(netlinks[i].provider_id);
				if (foundProvider >= 0) {
					splitedNetlinks[foundProvider].push(netlinks[i]);
				} else {
					providers_id.push(netlinks[i].provider_id);
					splitedNetlinks.push([netlinks[i]]);
				}
			}
			return splitedNetlinks;
		},

		splitByContract(netlinks) {
			let societies_id = [];
			let splitedNetlinks = [];
			for (let i = 0; i < netlinks.length; i++) {
				let foundContract = societies_id.indexOf(netlinks[i].contract_id);
				if (foundContract >= 0) {
					splitedNetlinks[foundContract].push(netlinks[i]);
				} else {
					societies_id.push(netlinks[i].contract_id);
					splitedNetlinks.push([netlinks[i]]);
				}
			}
			return splitedNetlinks;
		},

		splitByPeriod(netlinks) {
			let period = [];
			let splitedNetlinks = [];
			for (let i = 0; i < netlinks.length; i++) {
				let foundPeriod = period.indexOf(netlinks[i].period_date);
				if (foundPeriod >= 0) {
					splitedNetlinks[foundPeriod].push(netlinks[i]);
				} else {
					period.push(netlinks[i].period_date);
					splitedNetlinks.push([netlinks[i]]);
				}
			}
			return splitedNetlinks;
		},

		splitNetlinksForPurchase(netlinks) {
			let splitedByProviderNetlinks = this.splitByProvider(netlinks);
			let finalSplitedNetlinks = [];
			for (let i = 0; i < splitedByProviderNetlinks.length; i++) {
				let contractSplitedNetlinks = this.splitByContract(
					splitedByProviderNetlinks[i]
				);
				for (let j = 0; j < contractSplitedNetlinks.length; j++) {
					let periodSplitedNetlinks = this.splitByPeriod(
						contractSplitedNetlinks[j]
					);
					for (let k = 0; k < periodSplitedNetlinks.length; k++) {
						finalSplitedNetlinks.push(periodSplitedNetlinks[k]);
					}
				}
			}
			return finalSplitedNetlinks;
		},

		filterOutNoPriceNetlinks(netlinkList) {
			let netlinkFilteredList = [];
			let noPriceNetlinkList = [];
			for (let i = 0; i < netlinkList.length; i++) {
				if (netlinkList[i].price > 0) {
					netlinkFilteredList.push(netlinkList[i]);
				} else {
					noPriceNetlinkList.push(netlinkList[i]);
				}
			}
			return [noPriceNetlinkList, netlinkFilteredList];
		},

		filterOutAddedNetlinks(addedNetlinks) {
			let concatenatedAddedNetlinks = addedNetlinks.map(
				(netlink) => netlink.url_bought + netlink.landing_page
			);
			this.netlinkList = this.netlinkList.filter(
				(netlink) =>
					!concatenatedAddedNetlinks.includes(
						netlink.url_bought + netlink.landing_page
					)
			);
		},

		submitPurchases() {
			if (
				this.checkAllRowHaveNotValidStates(
					this.filterOutSelection(this.netlinkList)
				) == false
			) {
				if (this.countSelectedNetlinks(this.netlinkList) <= 0) {
					this.$vs.notify({
						title: "Echec",
						text: "Aucun netlink sélectionné.",
					});
					return;
				}
				if (this.selectedContract) {
					for (let netlink of this.netlinkList) {
						netlink.contract_id = this.selectedContract;
					}
				}
				let [noPriceNetlink, filteredSelectedNetlinks] =
					this.filterOutNoPriceNetlinks(
						this.filterOutSelection(this.netlinkList)
					);
				this.noPriceNetlink = noPriceNetlink;
				this.splitNetlinks = this.splitNetlinksForPurchase(
					filteredSelectedNetlinks
				);
				//console.log(noPriceNetlink);
				//console.log(filteredSelectedNetlinks);
				this.computePopupTableData().then((res) => {
					this.purchaseRecap = res;
					this.displayValidationPopup();
				});
			} else {
				this.$vs.notify({
					title: "Echec",
					text: "Des erreurs sont présentes parmi les netlinks sélectionnés.",
				});
			}
		},

		computePopupTableData() {
			return new Promise((resolve, reject) => {
				let purchaseTotal = this.splitNetlinks.length;
				let netlinkTotal = 0;
				let societyTotal = 0;
				let priceTotal = 0;

				let purchaseRecap = [];

				for (let i = 0; i < purchaseTotal; i++) {
					let foundSocietyRecapIndex = purchaseRecap.findIndex(
						(row) =>
							row.society_name ==
								this.getSocietyNameFromContractId(
									this.splitNetlinks[i][0].contract_id
								) && row.provider_id == this.splitNetlinks[i][0].provider_id
					);
					if (foundSocietyRecapIndex < 0) {
						purchaseRecap.push({
							society_name: this.getSocietyNameFromContractId(
								this.splitNetlinks[i][0].contract_id
							),
							netlink_total: 0,
							price_total: 0,
							provider_id: this.splitNetlinks[i][0].provider_id,
						});
						societyTotal += 1;
						foundSocietyRecapIndex = purchaseRecap.length - 1;
					}
					for (let j = 0; j < this.splitNetlinks[i].length; j++) {
						netlinkTotal += 1;
						purchaseRecap[foundSocietyRecapIndex].netlink_total += 1;
						priceTotal += parseFloat(this.splitNetlinks[i][j].price);
						purchaseRecap[foundSocietyRecapIndex].price_total += parseFloat(
							this.splitNetlinks[i][j].price
						);
					}
				}
				this.purchaseTotal = purchaseTotal;
				this.netlinkTotal = netlinkTotal;
				this.societyTotal = societyTotal;
				this.priceTotal = priceTotal;
				resolve(purchaseRecap);
			});
		},

		displayValidationPopup() {
			this.showValidationPopup = true;
		},

		declineProviders() {
			for (let i of this.netlinkList) {
				if (typeof i.provider_id !== "number") {
					let foundId = this.netlinkProviders.filter(
						(provider) => provider.society == i.provider_id
					);
					i.provider_id = foundId.length > 0 ? foundId[0].id : null;
				}
			}
			this.refreshCard++;
			this.newProviderList = [];
			this.showNewProviderPopup = false;
		},

		acceptProviders(providerList) {
			if (this.countSelectedProviders(this.newProviderList) <= 0) {
				this.$vs.notify({
					title: "Erreur",
					text: "Aucun prestataire sélectionné.",
				});
				return;
			}
			let check = true;
			for (let row of providerList) {
				this.validateContactInfo(row);
				if (row.notValid) check = false;
			}
			if (check) {
				this.openLoading();
				// ADD PROVIDERS
				// allProviderSelected
				this.submitProviders(this.newProviderList).then((result) => {
					this.showNewProviderPopup = false;
					this.getAllProviders();
					let tmp = result.data[0];
					for (let x of tmp) {
						x["service_id_list"] = 10;
						this.netlinkProviders.push(x);
					}
					this.closeLoading();
					for (let i of this.netlinkList) {
						if (typeof i.provider_id !== "number") {
							let foundId = this.netlinkProviders.filter(
								(provider) => provider.society == i.provider_id
							);
							i.provider_id = foundId.length > 0 ? foundId[0].id : null;
						}
					}
					this.refreshCard++;
					this.$vs.notify({
						title: "Succès",
						text: "Tous les prestataires ont été ajoutés.",
					});
				});
			} else
				this.$vs.notify({
					title: "Erreur",
					text: "Un ou plusieurs champs invalides.",
				});
		},

		declinePurchases() {
			this.showValidationPopup = false;
		},

		acceptPurchases() {
			this.openLoading();
			this.submitForm(this.splitNetlinks, this.noPriceNetlink).then(
				(result) => {
					this.showValidationPopup = false;
					this.closeLoading();
					this.$vs.notify({
						title: "Succès",
						text: "Tous les netlinks ont été ajoutés.",
					});
					this.isPopupActive = false;
					this.$emit("refresh-data");
				}
			);
		},

		submitProviders(providers) {
			return new Promise((resolve, reject) => {
				this.$http
					.post(this.apiUrl + "providers/addMultiple", {
						providers: providers,
						service_id: 10,
					})
					.then((result) => {
						resolve(result);
					})
					.catch((e) => {
						reject(e);
					});
			});
		},

		submitForm(netlinkList, noPriceNetlinkList) {
			return new Promise((resolve, reject) => {
				if (netlinkList.length > 0 || noPriceNetlinkList.length > 0) {
					/*
					 * Purchase Netlink
					 * ADD Netlink Arrays lists
					 */
					let requests = [];
					if (netlinkList.length > 0) {
						for (let i = 0; i < netlinkList.length; i++) {
							if (netlinkList[i].length > 0) {
								let today = new Date(Date.now());
								let formatedDate = today.toISOString().substring(0, 10);
								formatedDate = formatedDate.split("/").reverse().join("-");
								formatedDate = formatedDate + " 02:00:00";

								let foundSociety = this.contractsSocietiesWithName.findIndex(
									(row) => row.contract_id == netlinkList[i][0].contract_id
								);

								let purchase = Purchase.getFormFields();
								purchase.user_id = this.activeUser.id;
								purchase.contract_society_id =
									foundSociety >= 0
										? this.contractsSocietiesWithName[foundSociety].society_id
										: 0;
								purchase.contract_id = netlinkList[i][0].contract_id;
								purchase.users_id = netlinkList[i][0].provider_id;
								purchase.service_id = this.netlinkService;
								purchase.bought_at = formatedDate;
								purchase.is_delivered = 0;
								purchase.period_date = netlinkList[i][0].period_date;
								purchase.mission_id = netlinkList[i][0].mission_id;
								purchase.provider_id = netlinkList[i][0].provider_id;

								let purchasePrice = 0.0;
								for (let j = 0; j < netlinkList[i].length; j++) {
									/*
									 * Compute prices
									 * //console.log(netlinkList[i][j])
									 */
									purchasePrice += parseFloat(netlinkList[i][j].price);
								}
								purchase.price = purchasePrice;
								// //console.log("purchasePrice", purchasePrice, "purchase.price", purchase.price)
								requests.push(this.addPurchase(purchase, netlinkList[i]));
							}
						}
						Promise.all(requests)
							.then((results) => {
								this.$vs.notify({
									title: "Succès",
									text: `${results.length} achats ajoutés avec succès.`,
								});
								let netlinkRequests = [];
								for (let result of results) {
									netlinkRequests.push(this.addNetlink(result[0], result[1]));
								}
								if (noPriceNetlinkList.length > 0) {
									netlinkRequests.push(
										this.addNetlink(null, noPriceNetlinkList)
									);
								}
								Promise.all(netlinkRequests)
									.then((result2) => {
										/*
										 * this.$vs.notify({title:'Succès',text:"Tous les netlinks ont été ajoutés."})
										 * this.returnPrevRoute();
										 */
										this.filterOutAddedNetlinks(
											this.filterOutSelection(this.netlinkList)
										);
										this.closeLoading();
										resolve(result2);
									})
									.catch((err2) => {
										//console.log(err2); reject(err2);
									});
							})
							.catch((err) => {
								this.$vs.notify({
									title: "Echec",
									text: "Des achats n'ont pas été ajoutés.",
								});
								this.closeLoading();
								//console.log(err); reject(err);
							});
					}
				} else {
					this.$vs.notify({
						title: "Echec",
						text: "Aucun netlink valide sélectionné.",
					});
				}
			});
		},

		downloadTemplate() {
			window.open(
				"https://docs.google.com/spreadsheets/d/14gQQv8yivxw279MmeW2hBEibsFdozPzjk5CSeYjfMFw/edit?usp=sharing",
				"_blank"
			);
			/*
			 * this.$http.get(this.apiUrl + "netlink/gettemplate")
			 * .then(result => {
			 *     //console.log("result", result)
			 *     let template_file = XLSX.read(result.data, {type:'base64', WTF:false})
			 *     XLSX.writeFile(template_file, "template_import_netlink.xlsx")
			 * })
			 * .catch(err => {
			 *     //console.log("err", err)
			 * })
			 */
		},
	},
};
</script>
<style>
body > .vs-tooltip {
	z-index: 55001;
}
</style>
